<template>
  <div id="page-footer">
    <hr>
    <h4>Links</h4>
    <ul>
      <li v-for="link in links" :key="link.name"><a :href="link.href" target="_blank">{{ link.name }}</a></li>
    </ul>
    <hr>
    <p>Copyright &copy; {{ currentYear }} by <a href="https://www.studio308.co">Studio 308</a></p>
  </div>
</template>

<script>
export default {
  name: 'page-footer',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      links: [
        {
          name: 'GitLab',
          href: 'https://gitlab.com/jonnypickett'
        },
        {
          name: 'Github',
          href: 'https://github.com/jonnypickett'
        },
        {
          name: 'LinkedIn',
          href: 'https://www.linkedin.com/in/jonathanpickett/'
        },
        {
          name: 'Twitter',
          href: 'https://twitter.com/jonnypickett'
        },
        {
          name: 'Instagram',
          href: 'https://www.instagram.com/jonnypickett/?hl=en'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/*#page-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}*/
#page-footer ul {
  padding: 0;
}
#page-footer ul li {
  display: inline;
  margin-right: 10px;
}
#page-footer ul li:last-child {
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// PageFooter.vue?87017dba